/*
  Routen der Mitarbeitenden-Ansicht (Rolle "User").

  Eine eigene, abschliessende Liste statt "User" in den Planungsrouten: jede
  Seite hier ruft nur Endpunkte auf, die das Backend für User freigibt
  (USER_WEB_ROUTES in backend_web/auth.py). Eine Planungsseite würde an der
  app_only-Schranke abprallen - und die meldet die Sitzung ab.
*/

import React, { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { apiGet } from "../../api";
import { AuthContext } from "../../AuthContext";
import BillingAccessGate from "../../components/BillingAccessGate";
import PrivateRoute from "../../PrivateRoute";
import { EMPLOYEE_ACCESS_LEVEL, EMPLOYEE_HOME_PATH } from "../../utils/accessLevels";
import ReportingEntry from "../reporting";
import PunchClockReporting from "../reporting/punch_clock";
import ShiftplanReporting from "../reporting/shiftplan";
import PunchClock from "../punch_clock";
import Settings from "../settings";
import EmployeeAvailability from "./availability";
import EmployeeShiftplan from "./shiftplan";

const ACCESS = [EMPLOYEE_ACCESS_LEVEL];

const GatedEmployeeShiftplan = () => (
  <BillingAccessGate featureKey="page.shiftplan">
    <EmployeeShiftplan />
  </BillingAccessGate>
);

/*
  Stempeluhr und "Erfasste Arbeitszeit" gibt es nur mit dem Zusatzmodul
  Stempeluhr (feature_special "punch_clock") - auch über einen direkten Link
  nicht. Ohne Modul geht es zu fallbackPath.
*/
function PunchClockModuleGate({ children, fallbackPath }) {
  const { logout } = useContext(AuthContext);
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    let active = true;
    apiGet("/api/web/feature-special/punch_clock", logout)
      .then((feature) => { if (active) setEnabled(Boolean(feature?.enabled)); })
      .catch(() => { if (active) setEnabled(false); });
    return () => { active = false; };
  }, [logout]);

  if (enabled === null) return null;
  return enabled ? children : <Navigate to={fallbackPath} replace />;
}

const GatedPunchClock = () => (
  <PunchClockModuleGate fallbackPath={EMPLOYEE_HOME_PATH}>
    <PunchClock />
  </PunchClockModuleGate>
);

// Ohne Modul zurück zur Berichtsauswahl, die den nächsten Bericht wählt.
const GatedPunchClockReport = () => (
  <PunchClockModuleGate fallbackPath="/report">
    <PunchClockReporting />
  </PunchClockModuleGate>
);

export default function EmployeeRoutes() {
  return (
    <Routes>
      <Route path="/shiftplan" element={<PrivateRoute component={GatedEmployeeShiftplan} accessLevels={ACCESS} />} />
      <Route path="/availability" element={<PrivateRoute component={EmployeeAvailability} accessLevels={ACCESS} />} />
      <Route path="/report" element={<PrivateRoute component={ReportingEntry} accessLevels={ACCESS} />} />
      <Route path="/punch_clock" element={<PrivateRoute component={GatedPunchClock} accessLevels={ACCESS} />} />
      <Route path="/report/punch-clock" element={<PrivateRoute component={GatedPunchClockReport} accessLevels={ACCESS} />} />
      <Route path="/report/shiftplan" element={<PrivateRoute component={ShiftplanReporting} accessLevels={ACCESS} />} />
      <Route path="/settings" element={<PrivateRoute component={Settings} accessLevels={ACCESS} />} />
      <Route path="*" element={<Navigate to={EMPLOYEE_HOME_PATH} replace />} />
    </Routes>
  );
}
